module.exports = __webpack_public_path__ + "static/media/icon-list-blue.770d6a0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-list-blue.svg
// module id = 1567
// module chunks = 0